import {
  IonButton,
  IonCol,
  IonGrid,
  IonInput,
  IonItem,
  IonLabel,
  IonRow,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import "./UserregistrationInputSecond.scss";
import { UserRegistrtionInputSecondControls } from "../UserRegistration.models";
import TermsAndPrivacy from "../../../components/Shared/TremsAndPrivacy/TermsAndPrivacy";
import { ERROR } from "../../../constants";
import { useToast } from "@agney/ir-toast";
import { useTranslation } from "react-i18next";

const UserRegistrationInputSecond: React.FC<
  UserRegistrtionInputSecondControls
> = (props) => {
  const { t } = useTranslation("settings");

  const loadIntial = () => {
    props.inputs.email.current!.value = props.inputData.email;
    props.inputs.pager.current!.value =
      props.inputData.pager == "null" ? "" : props.inputData.pager;
    props.inputs.emailPreferance.current!.value =
      props.inputData.contact_preference.email;
    props.inputs.pagerPreferance.current!.value =
      props.inputData.contact_preference.pager;
    props.inputs.primaryPreferance.current!.value =
      props.inputData.contact_preference.mobile_number;
    props.inputs.secondryPreferance.current!.value =
      props.inputData.contact_preference.alternate_number;
    if (!props.inputData.primaryPhone) {
      props.contactDetails.forEach((value) => {
        if (value.number_status == 1) {
          props.inputs.primaryPhone.current!.value = normalizeInput(
            value.phone_number
          );
          props.inputs.primaryType.current!.value = value.number_type;
        } else {
          props.inputs.secondryPhone.current!.value = normalizeInput(
            value.phone_number
          );
          props.inputs.secondryType.current!.value = value.number_type;
        }
      });
    } else {
      props.inputs.primaryPhone.current!.value = normalizeInput(
        props.inputData.primaryPhone
      );
      props.inputs.secondryPhone.current!.value = normalizeInput(
        props.inputData.secondPhone
      );
      props.inputs.primaryType.current!.value = props.inputData.primaryType;
      props.inputs.secondryType.current!.value = props.inputData.secondType;
    }
  };

  const [type, setModalType] = useState<"terms" | "privacy">("terms");
  const [modelShow, setModelShow] = useState<boolean>(false);
  const [termsRead, setTermsRead] = useState<boolean>(false);
  const [privacyRead, setPrivacyRead] = useState<boolean>(false);
  const [isPrimaryTypeValid, setIsPrimaryTypeValid] = useState<boolean>(true);

  const Toast = useToast();

  const onOk = () => {
    if (type == "terms") {
      setModelShow(false);
      setTermsRead(true);
    } else {
      setModelShow(false);
      setPrivacyRead(true);
    }
  };

  const onTermsClick = () => {
    setModalType("terms");
    setModelShow(true);
  };

  const onPrivacyClick = () => {
    setModalType("privacy");
    setModelShow(true);
  };

  useEffect(loadIntial, []);

  const onPrimaryNumber = () => {
    props.typeSavePrimary(
      props.inputs.primaryType.current!.value,
      props.inputs.secondryType.current!.value
    );
    if (
      props.inputs.primaryPhone.current!.value &&
      !props.inputs.primaryType.current!.value
    ) {

      props.typePrimary(true);
    } else {
      props.typePrimary(false);
    }
  };

  const onSeconadyNumber = () => {
    props.typeSaveSecondary(
      props.inputs.primaryType.current!.value,
      props.inputs.secondryType.current!.value
    );
    if (
      props.inputs.secondryPhone.current!.value &&
      props.inputs.secondryType.current!.value===3
    ) {
      props.typesecodary(true);
    } else {
      props.typesecodary(false);
    }
  };

  /**
   * @author T0514
   * @date 07-Sept-2021
   * @description Checks the contact preferences are valid
   * @param nil
   * @return boolean whether the preferences are valid or not
   */
  const getPreferenceValidity = () => {
    let validStatus = true;
    let errorMsg = "";
    const preferenceForm: any = {
      email: props.inputs.emailPreferance.current!.value,
      pager: props.inputs.pagerPreferance.current!.value,
      mobile_number: props.inputs.primaryPreferance.current!.value,
      alternate_number: props.inputs.secondryPreferance.current!.value,
    };
    const USER_DETAILS = [
      {
        key: "None",
        value: "",
      },
      {
        key: "First",
        value: 1,
      },
      {
        key: "Second",
        value: 2,
      },
      {
        key: "Third",
        value: 3,
      },
      {
        key: "Fourth",
        value: 4,
      },
    ];
    const preference_keys = [
      "email",
      "pager",
      "mobile_number",
      "alternate_number",
    ];

    const contact_preference: any = preferenceForm;

    if (contact_preference) {
      Object.keys(contact_preference).forEach((k) => {
        contact_preference[k] =
          contact_preference[k] === null || contact_preference[k] === undefined
            ? ""
            : contact_preference[k];
      });
    }

    // for (const key of preference_keys) {
    //     // if (!this.userForm.value[key] && contact_preference[key] !== '') {
    //     if (!preferenceForm[key] && contact_preference[key] !== ) {
    //       validStatus = false;
    //       errorMsg = ERROR.PreferenceError.INCORRECT_PREFERENCE;
    //   }
    // }

    const valueArray = Object.keys(contact_preference).map((key) =>
      Number(contact_preference[key])
    );
    let ind = 0;
    let sum = 0;
    for (const prfrnce of USER_DETAILS) {
      if (
        prfrnce.value !== "" &&
        valueArray.filter((x) => x === Number(prfrnce.value)).length > 1
      ) {
        validStatus = false;
        errorMsg = ERROR.PreferenceError.SAME_PREFERENCE;
        break;
      }
      sum =
        sum +
        Number(valueArray[ind] !== 0 && valueArray[ind] ? valueArray[ind] : 0);
      ind += 1;
    }

    if (
      (!(sum === 0 || sum === 1 || sum === 3 || sum === 6 || sum === 10) &&
        validStatus) ||
      (sum === 3 &&
        valueArray.filter((x) => x === 0).length > preference_keys.length - 2)
    ) {
      validStatus = false;
      errorMsg = ERROR.PreferenceError.PREFERENCE;
    }

    if (!validStatus) {
      Toast.error(errorMsg);
    }
    return validStatus;
  };

  const onSaveClick = () => {
    const preferenceValidity = getPreferenceValidity();
    const isMandatoryFieldsEntered = checkMandatoryFieldsEntered();
    if(props.typeValidation.primaryType){
      setIsPrimaryTypeValid(false)
    }else{
      setIsPrimaryTypeValid(true)
    }
    if (preferenceValidity && isMandatoryFieldsEntered && !props.typeValidation.primaryType) {
      props.onSave();
    }
  };

  const checkMandatoryFieldsEntered = () => {
    let mandatoryStatus = true;
    const primaryPhone = normalizeInput(
      "" + props.inputs.primaryPhone.current!.value
    );
    const secondaryPhone = normalizeInput(
      "" + props.inputs.secondryPhone.current!.value
    );
   if (primaryPhone.length !== 9) {
  mandatoryStatus = false;
  Toast.error("Enter valid primary phone number");
} else if (secondaryPhone.length !== 9 && secondaryPhone.length !== 0) {
  mandatoryStatus = false;
  Toast.error("Enter valid secondary phone number");
}
    return mandatoryStatus;
  };

  const normalizeInputPrimary = () => {
    // return nothing if no value
    const value = "" + props.inputs.primaryPhone.current!.value;
    props.inputs.primaryPhone.current!.value = normalizeInput(value);
  };

  const normalizeInputSecondary = () => {
    // return nothing if no value
    const value = "" + props.inputs.secondryPhone.current!.value;
    props.inputs.secondryPhone.current!.value = normalizeInput(value);
  };

 const normalizeInput = (value: string) => {
  // allow only numbers
  let currentValue = value.replace(/[^\d]/g, "");

  // 🚨 LIMIT to 9 digits
  currentValue = currentValue.slice(0, 9);

  return currentValue;
};

  return (
    <>
      {modelShow && (
        <TermsAndPrivacy
          page="registration"
          type={type}
          showModal={modelShow}
          onOk={onOk}
          onCancel={() => {
            setModelShow(false);
          }}
        />
      )}

      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSaveClick();
        }}
      >
        {" "}
        {props.displayMyProfileEdit ? (
          <IonGrid className="profile-edit-details-container">
            <IonRow>
              <IonRow className="ion-row-full-width">
                <div className="input-width-my-prof">
                  <IonItem>
                    <IonLabel position="floating">
                      <span className="red-star">*</span> {t("email")}
                    </IonLabel>
                    <IonInput
                      required={true}
                      type="email"
                      ref={props.inputs.email}
                      readonly={true}
                    ></IonInput>
                  </IonItem>
                </div>
                <div className="select-width-my-prof">
                  <IonItem>
                    <span className="preference-option">{t("emailPreference")}</span>
                    <IonSelect ref={props.inputs.emailPreferance}>
                      <IonLabel position="floating">Preference </IonLabel>
                      <IonSelectOption value={0}>None</IonSelectOption>
                      <IonSelectOption value={1}>1</IonSelectOption>
                      <IonSelectOption value={2}>2</IonSelectOption>
                      <IonSelectOption value={3}>3</IonSelectOption>
                      <IonSelectOption value={4}>4</IonSelectOption>
                    </IonSelect>
                  </IonItem>
                </div>
              </IonRow>
            </IonRow>
            <IonRow>
              <IonRow className="ion-row-full-width">
                <div className="input-width-my-prof">
                  <IonItem>
                    <IonLabel position="floating">{t("pager")}</IonLabel>
                    <IonInput ref={props.inputs.pager}></IonInput>
                  </IonItem>
                </div>
                <div className="select-width-my-prof">
                  <IonItem>
                    <span className="preference-option">{t("pagerPreference")}</span>
                    {/* </IonItem> */}
                    {/* <IonItem> */}
                    <IonSelect ref={props.inputs.pagerPreferance}>
                      <IonLabel position="floating">Preference </IonLabel>
                      <IonSelectOption value={0}>None</IonSelectOption>
                      <IonSelectOption value={1}>1</IonSelectOption>
                      <IonSelectOption value={2}>2</IonSelectOption>
                      <IonSelectOption value={3}>3</IonSelectOption>
                      <IonSelectOption value={4}>4</IonSelectOption>
                    </IonSelect>
                  </IonItem>
                </div>
              </IonRow>
            </IonRow>
            <IonRow>
              <IonRow className="ion-row-full-width">
                <div className="input-width-my-prof">
                  <IonItem>
                    <IonLabel position="floating">
                      <span className="red-star">*</span> {t("primaryPhone")}
                    </IonLabel>
                    <IonInput
                      maxlength={9}
                      minlength={8}
                      ref={props.inputs.primaryPhone}
                      required={true}
                      onIonChange={normalizeInputPrimary}
                      onIonBlur={onPrimaryNumber}
                    ></IonInput>
                  </IonItem>
                </div>
                <div className="select-width-my-prof">
                  <IonItem>
                    <span className="preference-option">
                      {t("primaryNumberPreference")}{" "}
                    </span>
                    {/* </IonItem> */}
                    {/* <IonItem> */}
                    <IonSelect ref={props.inputs.primaryPreferance}>
                      <IonLabel position="floating">Preference </IonLabel>
                      <IonSelectOption value={0}>None</IonSelectOption>
                      <IonSelectOption value={1}>1</IonSelectOption>
                      <IonSelectOption value={2}>2</IonSelectOption>
                      <IonSelectOption value={3}>3</IonSelectOption>
                      <IonSelectOption value={4}>4</IonSelectOption>
                    </IonSelect>
                  </IonItem>
                </div>
              </IonRow>
              {props.typeValidation.primaryType && (
                <div className="feedback">{t("typeRequired")}</div>
              )}
              <div className="type-my-prof">
                <IonItem>
                  <span className="preference-option">
                    <span className="red-star">*</span>{t("primaryPhoneType")}{" "}
                  </span>
                  <IonSelect
                    onIonChange={onPrimaryNumber}
                    ref={props.inputs.primaryType}
                    value={props.inputData.primaryType}
                  >
                    <IonLabel position="floating">
                      <span className="red-star">*</span>{t("phoneType")}{" "}
                    </IonLabel>
                    <IonSelectOption value={0}>None</IonSelectOption>
                    <IonSelectOption value={1}>Mobile</IonSelectOption>
                    <IonSelectOption value={2}>Landline</IonSelectOption>
                  </IonSelect>
                </IonItem>
              </div>
            </IonRow>
            <IonRow>
              <IonRow className="ion-row-full-width">
                <div className="input-width-my-prof">
                  <IonItem>
                    <IonLabel position="floating">
                      {t("secondaryPhone")}{" "}
                    </IonLabel>
                    <IonInput
                      maxlength={8}
                      minlength={9}
                      ref={props.inputs.secondryPhone}
                      onIonChange={normalizeInputSecondary}
                      onIonBlur={onSeconadyNumber}
                    ></IonInput>
                  </IonItem>
                </div>
                <div className="select-width-my-prof">
                  <IonItem>
                    <span className="preference-option">
                      {t("secondaryNumberPreference")}{" "}
                    </span>
                    {/* </IonItem> */}
                    {/* <IonItem> */}
                    <IonSelect ref={props.inputs.secondryPreferance}>
                      <IonLabel position="floating">Preference </IonLabel>
                      <IonSelectOption value={0}>None</IonSelectOption>
                      <IonSelectOption value={1}>1</IonSelectOption>
                      <IonSelectOption value={2}>2</IonSelectOption>
                      <IonSelectOption value={3}>3</IonSelectOption>
                      <IonSelectOption value={4}>4</IonSelectOption>
                    </IonSelect>
                  </IonItem>
                </div>
              </IonRow>
              {props.typeValidation.secondaryType && (
                <div className="feedback">{t("typeRequired")}</div>
              )}
              <div className="type-my-prof">
                <IonItem>
                  <span className="preference-option">
                    Secondary Phone Type
                  </span>
                  <IonSelect
                    ref={props.inputs.secondryType}
                    value={props.inputData.secondType}
                    onIonChange={onSeconadyNumber}
                  >
                    <IonLabel position="floating">Phone Type </IonLabel>
                    <IonSelectOption value={3}>None</IonSelectOption>
                    <IonSelectOption value={1}>Mobile</IonSelectOption>
                    <IonSelectOption value={2}>Landline</IonSelectOption>
                  </IonSelect>
                </IonItem>
              </div>
            </IonRow>
            {props.isTermsPrivacyActive && (
              <div>
                <IonRow>
                  <IonItem>
                    <IonLabel>
                     {t("agreeTerms")}
                    </IonLabel>
                  </IonItem>
                </IonRow>
                <div>
                  <div className="termsandprivacy">
                    <input
                      type="checkbox"
                      checked={termsRead}
                      onChange={() => setTermsRead(!termsRead)}
                      ref={props.inputs.iAgreeTerms}
                      disabled={!termsRead}
                    ></input>
                    <span className="terms clickable" onClick={onTermsClick}>
                     {t("termsOfService")}
                    </span>
                  </div>
                  <div className="termsandprivacy">
                    <input
                      type="checkbox"
                      checked={privacyRead}
                      onChange={() => setPrivacyRead(!privacyRead)}
                      ref={props.inputs.iAgreePrivacy}
                      disabled={!privacyRead}
                    ></input>
                    <span
                      className="termsandprivacy clickable"
                      onClick={onPrivacyClick}
                    >
                   {t("privacyPolicy")}
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div className="reg-button-container">
              <IonRow>
                {/* <IonCol size="3"></IonCol> */}
                <IonCol size="5">
                  {props.submitBtnMyProfile ? (
                    <IonButton
                      color="medium"
                      onClick={props.onBack}
                      className="back-btn button secondary-btn  btn-curved"
                    >
                      Back
                    </IonButton>
                  ) : (
                    <IonButton
                      color="medium"
                      onClick={props.onBack}
                      className="button secondary-btn login-btn btn-curved"
                    >
                      {t("back")}
                    </IonButton>
                  )}
                </IonCol>
                <IonCol size="5">
                  {props.submitBtnMyProfile ? (
                    <IonButton
                      disabled={
                        props.typeValidation.primaryType ||
                        props.typeValidation.secondaryType
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        onSaveClick();
                      }}
                      className="submit-btn button primary-btn btn-curved"
                    >
                      {t("save")}
                    </IonButton>
                  ) : (
                    <IonButton
                      disabled={
                        !(termsRead && privacyRead) ||
                        props.typeValidation.primaryType ||
                        props.typeValidation.secondaryType
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        onSaveClick();
                      }}
                      className="button primary-btn login-btn btn-curved"
                    >
                      Save
                    </IonButton>
                  )}
                </IonCol>
                <IonCol size="2"></IonCol>
              </IonRow>
            </div>
          </IonGrid>
        ) : (
          <IonGrid>
            <IonRow>
              <IonCol sizeXs="12"  sizeSm="12" sizeMd="9" sizeLg="9" sizeXl="9">
                <IonRow>
                  <div className="input-width">
                    <IonItem>
                      <IonLabel position="floating">
                        <span className="red-star">*</span> Email
                      </IonLabel>
                      <IonInput
                        required={true}
                        type="email"
                        ref={props.inputs.email}
                        readonly={true}
                      ></IonInput>
                    </IonItem>
                  </div>
                  <div className="select-width">
                    <IonItem>
                      <IonLabel position="floating">Preference </IonLabel>
                      <IonSelect ref={props.inputs.emailPreferance}>
                        <IonSelectOption value={0}>None</IonSelectOption>
                        <IonSelectOption value={1}>1</IonSelectOption>
                        <IonSelectOption value={2}>2</IonSelectOption>
                        <IonSelectOption value={3}>3</IonSelectOption>
                        <IonSelectOption value={4}>4</IonSelectOption>
                      </IonSelect>
                    </IonItem>
                  </div>
                </IonRow>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol sizeXs="12"  sizeSm="12" sizeMd="9" sizeLg="9" sizeXl="9">
                <IonRow>
                  <div className="input-width">
                    <IonItem>
                      <IonLabel position="floating">Pager</IonLabel>
                      <IonInput ref={props.inputs.pager}></IonInput>
                    </IonItem>
                  </div>
                  <div className="select-width">
                    <IonItem>
                      <IonLabel position="floating">Preference </IonLabel>
                      <IonSelect ref={props.inputs.pagerPreferance}>
                        <IonSelectOption value={0}>None</IonSelectOption>
                        <IonSelectOption value={1}>1</IonSelectOption>
                        <IonSelectOption value={2}>2</IonSelectOption>
                        <IonSelectOption value={3}>3</IonSelectOption>
                        <IonSelectOption value={4}>4</IonSelectOption>
                      </IonSelect>
                    </IonItem>
                  </div>
                </IonRow>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="9">
                <IonRow>
                  <div className="input-width">
                    <IonItem>
                      <IonLabel position="floating">
                        <span className="red-star">*</span> Primary Phone Number
                      </IonLabel>
                      <IonInput
                        maxlength={9}
                        minlength={8}
                        ref={props.inputs.primaryPhone}
                        required={true}
                        onIonChange={normalizeInputPrimary}
                        onIonBlur={onPrimaryNumber}
                      ></IonInput>
                    </IonItem>
                  </div>
                  <div className="select-width">
                    <IonItem>
                      <IonLabel position="floating">Preference </IonLabel>
                      <IonSelect ref={props.inputs.primaryPreferance}>
                        <IonSelectOption value={0}>None</IonSelectOption>
                        <IonSelectOption value={1}>1</IonSelectOption>
                        <IonSelectOption value={2}>2</IonSelectOption>
                        <IonSelectOption value={3}>3</IonSelectOption>
                        <IonSelectOption value={4}>4</IonSelectOption>
                      </IonSelect>
                    </IonItem>
                  </div>
                </IonRow>
              </IonCol>
                

              <IonCol size="3">
                <div className="type">
                  <IonItem>
                    <IonLabel position="floating">
                      <span className="red-star">*</span>Type{" "}
                    </IonLabel>
                    <IonSelect
                      onIonChange={onPrimaryNumber}
                      ref={props.inputs.primaryType}
                      value={props.inputData.primaryType}
                    >
                      <IonSelectOption value={0}>None</IonSelectOption>
                      <IonSelectOption value={1}>Mobile</IonSelectOption>
                      <IonSelectOption value={2}>Landline</IonSelectOption>
                    </IonSelect>
                  </IonItem>
                </div>
                {!isPrimaryTypeValid && (
                  <div className="feedback" style={{textAlign:"left"}}>Type is required</div>
                )}
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="9">
                <IonRow>
                  <div className="input-width">
                    <IonItem>
                      <IonLabel position="floating">
                        Secondary Phone Number{" "}
                      </IonLabel>
                      <IonInput
                        maxlength={9}
                        minlength={8}
                        ref={props.inputs.secondryPhone}
                        onIonChange={normalizeInputSecondary}
                        onIonBlur={onSeconadyNumber}
                      ></IonInput>
                    </IonItem>
                  </div>
                  <div className="select-width">
                    <IonItem>
                      <IonLabel position="floating">Preference </IonLabel>
                      <IonSelect ref={props.inputs.secondryPreferance}>
                        <IonSelectOption value={0}>None</IonSelectOption>
                        <IonSelectOption value={1}>1</IonSelectOption>
                        <IonSelectOption value={2}>2</IonSelectOption>
                        <IonSelectOption value={3}>3</IonSelectOption>
                        <IonSelectOption value={4}>4</IonSelectOption>
                      </IonSelect>
                    </IonItem>
                  </div>
                </IonRow>
                
              </IonCol>
              <IonCol size="3">
                <div className="type">
                  <IonItem>
                    <IonLabel position="floating">Type </IonLabel>
                    <IonSelect
                      ref={props.inputs.secondryType}
                      value={props.inputData.secondType}
                      onIonChange={onSeconadyNumber}
                    >
                      <IonSelectOption value={3}>None</IonSelectOption>
                      <IonSelectOption value={1}>Mobile</IonSelectOption>
                      <IonSelectOption value={2}>Landline</IonSelectOption>
                    </IonSelect>
                  </IonItem>
                </div>
                {props.typeValidation.secondaryType && (
                  <div className="feedback" style={{textAlign:"left"}}>Type is required</div>
                )}
              </IonCol>
            </IonRow>
            {/* } */}
            {props.isTermsPrivacyActive && (
              <div>
                <IonRow>
                  <IonItem>
                    <IonLabel>
                      I Agree to the Nserix Terms and Privacy
                    </IonLabel>
                  </IonItem>
                </IonRow>
                <div>
                  <div className="termsandprivacy">
                    <input
                      type="checkbox"
                      checked={termsRead}
                      onChange={() => setTermsRead(!termsRead)}
                      ref={props.inputs.iAgreeTerms}
                      disabled={!termsRead}
                    ></input>
                    <span className="terms clickable" onClick={onTermsClick}>
                      Terms of Service
                    </span>
                  </div>
                  <div className="termsandprivacy">
                    <input
                      type="checkbox"
                      checked={privacyRead}
                      onChange={() => setPrivacyRead(!privacyRead)}
                      ref={props.inputs.iAgreePrivacy}
                      disabled={!privacyRead}
                    ></input>
                    <span
                      className="termsandprivacy clickable"
                      onClick={onPrivacyClick}
                    >
                      Privacy Policy
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div className="reg-button-container">
              <IonRow>
                {/* <IonCol size="3"></IonCol> */}
                <IonCol size="5">
                  {props.submitBtnMyProfile ? (
                    <IonButton
                      onClick={props.onBack}
                      className="back-btn button secondary-btn btn-curved"
                    >
                      Back
                    </IonButton>
                  ) : (
                    <IonButton
                      onClick={props.onBack}
                      className="button secondary-btn login-btn btn-curved"
                    >
                      Back
                    </IonButton>
                  )}
                </IonCol>
                <IonCol size="5">
                  {props.submitBtnMyProfile ? (
                    <IonButton
                      disabled={
                        props.typeValidation.primaryType ||
                        props.typeValidation.secondaryType
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        onSaveClick();
                      }}
                      className="button primary-btn btn-curved"
                    >
                      Save
                    </IonButton>
                  ) : (
                    <IonButton
                      disabled={
                        !(termsRead && privacyRead) 
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        onSaveClick();
                      }}
                      className="button primary-btn login-btn btn-curved"
                    >
                      Save
                    </IonButton>
                  )}
                </IonCol>
                <IonCol size="2"></IonCol>
              </IonRow>
            </div>
          </IonGrid>
        )}
      </form>
    </>
  );
};

export default UserRegistrationInputSecond;
